import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Confirm16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M3.30087 11.8454L2.08085 9.4727C1.89502 9.1113 2.0404 8.66924 2.40556 8.48533C2.77072 8.30142 3.21738 8.4453 3.40321 8.8067L4.62428 11.1815C4.6374 11.2071 4.65672 11.2298 4.68022 11.2467C4.70372 11.2637 4.73095 11.2749 4.75967 11.2793C4.78838 11.2838 4.81776 11.2815 4.84538 11.2725C4.87301 11.2635 4.89808 11.2482 4.91854 11.2278L4.91979 11.2265L12.7326 3.466C13.0218 3.17874 13.4915 3.17789 13.7818 3.46411C14.072 3.75032 14.0729 4.21521 13.7837 4.50246L5.97242 12.2614M3.30087 11.8454C3.42007 12.0783 3.5935 12.2801 3.80675 12.4338C4.0203 12.5877 4.26774 12.6892 4.5287 12.7299C4.78965 12.7706 5.05664 12.7493 5.30767 12.6679C5.55835 12.5865 5.78675 12.4466 5.97242 12.2614"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
